export default "__VITE_ASSET__482cb968__"